/* eslint-disable */
import React from 'react'
import {accounting} from 'accounting'
import jMoment from 'moment-jalaali'

class StatisticalComponent extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    let pageNumber = sessionStorage.getItem('pageNumber')
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let {data: statistical, aggregation} = this.props
    return (
      <div className="showBaseTable print">
        <table className="baseTable">
          <tbody>
            <tr className="firstRow">
              <td>ردیف</td>
              <td>نام</td>
              <td>موبایل</td>
              <td>شناسه پارت تحویل</td>
              <td>مبلغ (ریال)</td>
              <td>بازه زمانی</td>
              <td>نحوه پرداخت</td>
              <td>اسم بانک</td>
            </tr>

            {statistical.map((item, index) => (
              <tr key={index}>
                <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                <td>{item.driver == null ? '-' : item.driver.name}</td>
                <td>{item.driver == null ? '-' : item.driver.mobile}</td>
                <td>{item.planId}</td>
                <td className="priceCell">{accounting.formatMoney(item.paymentAmount, '', ',')}</td>
                <td>
                  {jMoment(item.planDate).format('jYYYY/jMM/jDD') +
                    ' - ' +
                    item.planTimeFrom +
                    ' تا ' +
                    item.planTimeTo}
                </td>
                <td>{item.account.name}</td>
                <td>{item.account.bank}</td>
              </tr>
            ))}
            <tr>
              <td colSpan={4} />
              <td className="priceCell">{accounting.formatMoney(aggregation.amount, '', ',')}</td>
              <td colSpan={4} />
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}
export default StatisticalComponent
